import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import LocationsList from '~/containers/locationsList/locationsList';

export default class CustomersPage extends Component {
  render() {
    const createButton = (
      <Link to="/settings/locations/create">
        <Button color="primary">New Location</Button>
      </Link>
    );
    return (
      <Page>
        <TitleBar back="/settings" backText="Settings" title="Locations" button={createButton} />
        <LocationsList />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/locations/locations.jsx